import { LogoFileMimeType } from 'libs/end-to-end/src/logos';
import { z } from 'zod';

/**
 * Schema for validating presigned URL requests for uploading organization logos
 * @remarks
 * This schema ensures the required properties are present when requesting
 * a presigned URL for uploading an organization's logo
 */
export const UploadOrganizationLogoRequestSchema = z.object({
  /** The MIME type of the file being uploaded (e.g., 'image/jpeg', 'image/png') */
  fileMimeType: LogoFileMimeType,
  /** The unique identifier of the organization */
  organizationId: z.string(),
  /** The URL of the file being uploaded */
  fileUrl: z.string(),
});

/** Type definition derived from the OrganizationLogoUploadPresignedSchema */
export type OrganizationLogoUploadPresignedRequest = z.infer<
  typeof UploadOrganizationLogoRequestSchema
>;
